module.exports = __webpack_public_path__ + "img/cw.9dae2cf3.svg";